import { SurfHeight } from './units';

export interface RewindStill {
  time: number;
  urlSuffix: string;
}

export interface Storyboard {
  columns: number;
  images: string[];
  rows: number;
  storyboardHeight: number;
  storyboardWidth: number;
  thumbnailHeight: number;
  thumbnailWidth: number;
}

export interface StillsResolutionConfig {
  resolutions: string[];
  preloadResolutions: string[];
}

export interface PlayerStills {
  baseUrl: string;
  stills: RewindStill[];
  storyboards_sized?: Record<string, Storyboard>;
  storyboards: Storyboard[];
}

export enum MLStatus {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  NOT_RUN = 'NOT_RUN',
  NOT_ML_CAM = 'NOT_ML_CAM',
}

export type RecordingBase = {
  startDate: string;
  endDate: string;
  recordingUrl: string;
  cameraId: string;
  thumbSmallUrl?: string;
};

export type RewindRecording = RecordingBase & {
  alias: string;
  thumbSmallUrl: string;
  thumbLargeUrl: string;
  highlights?: {
    url: string;
  };
  clips?: Array<{
    type: 'HIGHLIGHTS_REEL' | 'SINGLE_HIGHLIGHT';
    url: string;
    thumbnails?: {
      url: string;
      sizes?: string[];
    };
  }>;
  associated: { units: { waves: { height: SurfHeight } } };
  mlStatus: MLStatus;
  waves?: WaveWithInsights[];
  insights?: {
    waves?: WaveWithInsights[];
    isVisibilityBad?: boolean;
    lowWaveCount?: boolean;
  };
  playerStillsManifest?: string;
};

export enum SurfedDirection {
  LEFT = 'left',
  RIGHT = 'right',
  NONE = 'none',
  BOTH = 'both',
}

export type WaveWithInsights = {
  endTime?: string;
  height: number;
  startTime: string;
  surfedDirection: SurfedDirection;
};
